module.exports = __webpack_public_path__ + "static/media/yanpan2.2760c06a.png";